import { forwardRef } from "react";
import "../LineBarComposedChart.scss";

const ChartTooltip = forwardRef((props, ref) => {
  return <div ref={ref} className="line-bar-chart__tooltip" />;
});

ChartTooltip.displayName = "ChartTooltip";

export default ChartTooltip;
